<template>
  <div
    class="coupon-item j-select-coupon-item"
    :pointValue="
      fullReductType ? fullReductMoney + currency : discount + '%OFF'
    "
    v-if="!isEmpty"
    @click="updateActiveCouponId"
    :class="{ active: active, invalid: invalid }"
  >
    <div class="coupon-item-choose-ico" v-show="active"></div>
    <p class="coupon-item-name" v-if="fullReductType">
      {{ fullReductMoney }}
      <span class="coupon-item-currency">{{ currency }}</span>
    </p>
    <p class="coupon-item-name" v-else>{{ discount }}%OFF</p>
    <p class="coupon-item-tag">{{ tagText }}</p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney === 0">
      {{ languages.couponNoLimit }}
    </p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney > 0">
      {{
        languages.couponFuilCanUse
          .replace('${price}', fullReductLimitBottomMoney)
          .replace('${currency}', currency)
      }}
    </p>
    <!-- <p class="coupon-item-date">{{ startDate }}-{{ endDate }}</p> -->
    <p class="coupon-item-date">
      {{ languages.couponInvalidTime }}： {{ localEndDate }}
    </p>
    <p class="coupon-item-line"></p>
    <p class="coupon-item-tip">{{ useLimitTip }}</p>
    <p class="coupon-item-tip">
      {{
        languages.voucherLimitRegion
          ? languages.voucherLimitRegion.replaceAll('${currency}', currency)
          : ''
      }}
    </p>
    <p class="coupon-item-tip" v-if="discountType && discountLimitTopMoney">
      ({{
        languages.couponMaxDiscount
          .replace('${price}', discountLimitTopMoney)
          .replace('${currency}', currency)
      }})
    </p>
    <p class="coupon-item-tip" v-if="hasUsed">
      {{ languages.couponHasUsed }}：{{ localUsedDate }}
    </p>
    <p class="coupon-item-use" v-if="showItemUseBtn">
      <a
        class="coupon-item-use-btn j-click-coupon-item-use"
        :pointValue="
          fullReductType ? fullReductMoney + currency : discount + '%OFF'
        "
        href="javascript:;"
        @click="chooseGameActiveCoupon"
        >{{ languages.couponUseNow }}</a
      >
    </p>
    <!-- <div class="coupon-item-tag">
      <span class="coupon-item-tag-text">{{ tagText }}</span>
    </div> -->
  </div>
  <div class="coupon-item empty" :class="{ invalid: invalid }" v-else>
    <div class="coupon-item-empty-ico"></div>
    <p class="coupon-item-empty-text">{{ languages.couponHasNoCoupon }}</p>
  </div>
</template>

<script type="text/javascript">
import language from '../../store/languages';
import { times } from '../../utiles/numberPrecision';
export default {
  name: 'couponItem',
  props: [
    'info',
    'active',
    'invalid',
    'isEmpty',
    'languages',
    'showItemUseBtn'
  ],
  computed: {
    fullReductType() {
      return +this.info.TYPE === 0;
    },
    discountType() {
      return +this.info.TYPE === 1;
    },
    startDate() {
      return this.dateFormat(this.info.START_TIME);
    },
    endDate() {
      return this.dateFormat(this.info.EXPIRY_TIME);
    },
    localStartDate() {
      return this.localFormatTime(this.info.START_TIME);
    },
    localEndDate() {
      return this.localFormatTime(this.info.EXPIRY_TIME);
    },
    localUsedDate() {
      return this.localFormatTime(this.info.USE_TIME);
    },
    currency() {
      return this.info?.CURRENCY || '';
    },
    fullReductLimitBottomMoney() {
      return +this.info.LIMIT_BOTTOM_MONEY || 0;
    },
    fullReductMoney() {
      return this.info.REDUCTION_MONEY || 0;
    },
    discount() {
      return times(+this.info.DISCOUNT, 100);
    },
    discountLimitTopMoney() {
      return +this.info.LIMIT_TOP_MONEY;
    },
    tagText() {
      if (this.info.DESCRIPTION) {
        return this.info.DESCRIPTION;
      }
      if (this.fullReductType) {
        return this.languages.couponReductionType;
      }
      if (this.discountType) {
        return this.languages.couponDiscountType;
      }
      return '';
    },
    useLimitTip() {
      let tips = [];

      const productType = {
        coin: this.languages.couponOnlyCoinCanUse,
        package: this.languages.couponOnlyPackageCanUse,
        subscription: this.languages.couponOnlySubCanUse,
        currency: this.languages.couponOnlyDaibiCanUse
      };

      const hasPaytypeList =
        (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0;
      const hasProductList =
        (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0;
      const hasProductType = this.info.PRODUCT_TYPE || 0;

      if (hasProductType) {
        tips.push(productType[this.info.PRODUCT_TYPE]);
      }

      if (hasPaytypeList && hasProductList) {
        tips.push(this.languages.couponPartProductCanUse);
        tips.push(this.languages.couponPartPaytypeCanUse);
      } else if (hasPaytypeList && !hasProductList) {
        tips.push(this.languages.couponPartPaytypeCanUse);
      } else if (!hasPaytypeList && hasProductList) {
        tips.push(this.languages.couponPartProductCanUse);
      } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
        tips.push(this.languages.couponAllProductCanUse);
      }

      return tips.join(';');
    },
    hasUsed() {
      // -1 提单未支付 0 未使用 1 完成支付 2 回收
      return +this.info.STATE === 1 || +this.info.STATE === -1;
    }
  },
  methods: {
    // timestamp : 时间戳，单位为秒
    localFormatTime(timestamp) {
      return new Date(+timestamp * 1000).toLocaleString(language.language, {
        hour12: false,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
    },
    dateFormat(time) {
      const t = new Date(+time * 1000);
      const formate = 'Y-M-D h:m';
      let year = t.getFullYear();
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hour = t.getHours();
      let minu = t.getMinutes();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      minu = minu == 0 ? '00' : minu;
      const hash = {
        Y: year,
        M: month,
        D: day,
        h: hour,
        m: minu
      };
      return formate.replace(/\w/g, i => {
        return hash[i];
      });
    },
    chooseGameActiveCoupon() {
      this.updateGameActiveCouponId(this.info.COUPON_ID);
      this.$emit('closePopup');
      this.$route.path === '/vip_score' && this.$router.push({ path: '/' });
    },
    updateActiveCouponId() {
      this.$emit(
        'chooseCoupon',
        Object.assign({}, this.info, {
          tagText: this.tagText,
          fullReductMoney: this.fullReductMoney
        })
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/base.scss';
.coupon-item {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  background: url('../../assets/image/store/coupon-item.png') no-repeat;
  background-size: cover;
  padding: 54px 55px;
  box-sizing: border-box;
  text-align: left;
  font-size: 24px;
  color: #ffffff;
  border-radius: 5px;
  overflow: hidden;

  &-choose-ico {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 77px;
    height: 78px;
    background: url('../../assets/image/store/coupon-item-choose-ico.png')
      no-repeat;
  }

  &-name {
    font-size: 54px;
    color: #ffffff;
  }
  &-type {
    font-size: 30px;
    margin: 13px 0 13px;
  }
  &-line {
    width: 100%;
    height: 1px;
    margin: 27px auto;
    background-color: #fff;
  }
  &-tip {
    margin-bottom: 10px;
  }
  &-use {
    display: flex;
    justify-content: end;
    margin: 34px auto 0;
    &-btn {
      text-align: center;
      color: #ffffff;
      font-size: 36px;
      width: 282px;
      height: 71px;
      line-height: 71px;
      background-color: #b23434;
      cursor: pointer;
    }
  }
  &-tag {
    font-size: 30px;
    margin: 28px 0 13px;
    // color: #ffffff;
  }
  // &-tag {
  //   position: absolute;
  //   right: 0;
  //   top: -3px;
  //   height: 41px;
  //   line-height: 41px;
  //   border-radius: 5px;
  //   padding: 0 49px;
  //   color: #f65353;
  //   background: url('../../assets/image/store/coupon-tag.png') no-repeat;
  //   background-size: 100% 100%;
  //   &-text {
  //     display: inline-block;
  //     font-size: 24px;
  //   }
  // }
  &-empty-ico {
    width: 113px;
    height: 112px;
    background: url('../../assets/image/store/no-coupon.png') no-repeat;
  }
  &-empty-text {
    font-size: 40px;
    color: #ffffff;
    text-align: center;
    margin-top: 30px;
  }

  &.active {
    background: url('../../assets/image/store/coupon-item-active.png') no-repeat;
    background-size: cover;
  }

  &.invalid {
    background: #f7f7f7;
    color: #707070;
    border: solid 3px #d8d8d8;
    .coupon-item-name,
    .coupon-item-tag {
      color: #707070;
    }
    .coupon-item-line {
      background: #707070;
    }
    // .coupon-item-tag {
    //   background: url('../../assets/image/store/coupon-tag-valid.png') no-repeat;
    //   background-size: 100% 100%;
    // }
    // .coupon-item-tag-text {
    //   color: #707070;
    // }
  }

  &.empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 326px;
    &.invalid {
      .coupon-item-empty-ico {
        background: url('../../assets/image/store/no-coupon-2.png') no-repeat;
      }
      .coupon-item-empty-text {
        color: #707070;
      }
    }
  }
}
</style>
